<template>
    <div class="ui">
        <div class="relative-box">
            <span class="navigation" v-if="total > 1">
                <span class="cta-container">
                    <IconArrow
                        :class="['left', 'cta', leftDisabled && 'is-disabled']"
                        @click.native="previous"
                    />
                </span>
                <span class="cta-container">
                    <IconArrow
                        :class="['right', 'cta', rightDisabled && 'is-disabled']"
                        @click.native="next"
                    />
                </span>
            </span>
            <span class="pagination" v-if="total > 1"><transition mode="out-in"><span :key="count" class="value">{{count | undigit}}</span></transition>/{{total | undigit}}</span>
        </div>
        <slot/>
    </div>
</template>
<script>
import IconArrow from "@/components/IconArrow"
export default {
    components: {
        IconArrow
    },
    props: {
        slider: {
            type: Object,
            default() {}
        },
        idx: {
            type: Number,
            default: 0
        }
    },
    computed: {
        count() {
            return this.idx + 1
        },
        total() {
            return this.slider.slides.length
        },
        currentSlide() {
            return this.slider.slides[this.idx]
        },
        leftDisabled() {
            return this.idx < 1
        },
        rightDisabled() {
            return this.idx > this.total - 2
        }
    },
    methods: {
        previous() {
            this.$emit('previous')
        },
        next() {
            this.$emit('next')
        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"

.ui
    background-color: #ff2b2a
    color: #ffffff
    font-size: 28px
    font-weight: 500
    user-select: none
    padding: 0 8.25% 0 36%
    position: relative
    height: 120px
    margin-top: -120px
    display: flex
    align-items: center
    flex-direction: column
    justify-content: center

    .reverse &
        left: auto
        right: 0%
        padding: 4.625% 18% 4.625% 8.25%
        @include media-breakpoint-down($lg)
            padding: 4.625%

    @include media-breakpoint-down($lg)
        padding-left: 9.25%
        padding-right: 9.25%
        height: 78px
        margin-top: -78px
        max-width: 576px
        width: 100%
    @include media-breakpoint-down($sm)
        position: relative
        margin-top: 0
        .project-detail &
            width: 100%

    .relative-box
        display: flex
        justify-content: space-between
        align-items: center
        width: 100%

    .slim &
        margin-left: 4.25%
        // width: 30.125%
        width: 580px
        padding: 2.875% 3%
        @include media-breakpoint-down($md)
            max-width: 100%
            width: auto
            margin-right: 9.6%
            margin-left: 0
            margin-top: -78px
    .drilldown &
        @media print
            display: none
    &:after
        content: ""
        display: block
        height: 2px
        background-image: url('./../../assets/circle.svg')
        background-repeat: repeat-x
        background-size: 12px
        background-position: 0 50%
        position: absolute
        left: 0
        right: 0
        bottom: 0
        opacity: .3
        .drilldown &
            margin-left: 22%
            @include media-breakpoint-down($lg)
                margin-left: 0
        .reverse &
            margin-left: 0
            margin-right: 22%
.navigation
    display: flex
.cta-container
    width: 34px
    height: 30px
    // @include media-breakpoint-down($lg)
    //     width: 26px
    //     height: 22px
    @include media-breakpoint-down($sm)
        width: 17px
        height: 34px

    &:first-child
        margin-right: 1em
        @include media-breakpoint-down($sm)
            margin-right: .625em
    .cta
        cursor: pointer
        width: 100% !important
        height: 100% !important
        /deep/ path
            fill: #ffffff
        &.left
            transform: scale(-1, 1)
        &.is-disabled
            pointer-events: none
            opacity: 0.3
            /deep/ path
                fill: #000000
.pagination
    @include media-breakpoint-down($sm)
        font-size: 14px
.value
    transition: opacity .2s
    will-change: opacity
    display: inline-block
    &.v-enter
        // transform: translateY(16px) translateX(-6px)
        opacity: 0
    &.v-leave-to
        // transform: translateY(-16px) translateX(6px)
        opacity: 0
</style>
